import Vue from 'vue';
import Vuex from 'vuex';

import createLogger from 'vuex/dist/logger';

import auth from './auth';
import errors from './errors';
import nav from './nav';
import consents from './consents';
import profileProviders from './profileProviders';
import datastoreProviders from './datastoreProviders';
import profile from './profile';

Vue.use(Vuex);
Vue.config.debug = true;

const debug = process.env.NODE_ENV !== 'production';
const modules = {
    auth,
    errors,
    nav,
    consents,
    profileProviders,
    datastoreProviders,
    profile,
};

export default new Vuex.Store({
    modules,
    strict: debug,
    plugins: debug ? [createLogger()] : [],
});



// WEBPACK FOOTER //
// ./src/store/index.js